import React, { useState } from "react";
import { generateresponse } from "../AI_Call/GeminiAI"; // Import the API function

const AIDetectorTool = ({ darkMode }) => {
  const [text, setText] = useState("");
  const [analysisResult, setAnalysisResult] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleAnalyze = async () => {
    if (text.trim().split(/\s+/).length < 80) {
      alert("Please enter at least 80 words to analyze.");
      return;
    }

    setIsAnalyzing(true);

    try {
      const prompt = "Analyze the likelihood of this text being AI-generated and just provide a percentage number.";
      const response = await generateresponse(prompt, text); // Call the imported API function

      console.log("API Response:", response); // Log the response for debugging

      // Extract the percentage value from the response
      const likelihood =
        response.candidates &&
        response.candidates[0] &&
        response.candidates[0].content &&
        response.candidates[0].content.parts &&
        response.candidates[0].content.parts[0] &&
        response.candidates[0].content.parts[0].text
          ? response.candidates[0].content.parts[0].text.trim()
          : "No percentage provided";

      setAnalysisResult(likelihood); // Update the state with the extracted percentage
    } catch (error) {
      console.error("Error analyzing text:", error);
      alert("An error occurred while analyzing. Please try again.");
    } finally {
      setIsAnalyzing(false);
    }
  };

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      backgroundColor: darkMode ? "#333" : "#f9f9f9",
      color: darkMode ? "#fff" : "#000",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      transition: "background-color 0.3s ease, color 0.3s ease",
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: "1200px",
      marginTop: "20px",
      backgroundColor: darkMode ? "#444" : "#fff",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    leftPanel: {
      flex: 3,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    textarea: {
      width: "90%",
      height: "400px",
      fontSize: "16px",
      padding: "10px",
      border: darkMode ? "1px solid #555" : "1px solid #ddd",
      borderRadius: "5px",
      backgroundColor: darkMode ? "#555" : "#fff",
      color: darkMode ? "#fff" : "#000",
      resize: "none",
    },
    rightPanel: {
      flex: 1,
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
    },
    analyzeButton: {
      padding: "15px 30px",
      fontSize: "18px",
      fontWeight: "bold",
      backgroundColor: darkMode ? "#2ECC71" : "green",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      transition: "background-color 0.3s ease",
    },
  };

  return (
    <div style={styles.container}>
      <main style={styles.content}>
        {/* Input Area */}
        <div style={styles.leftPanel}>
          <p>To analyze text, add at least 80 words.</p>
          <textarea
            style={styles.textarea}
            placeholder="Enter your text here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        {/* Output Area */}
        <div style={styles.rightPanel}>
          {analysisResult ? (
            <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              {analysisResult}% Likely AI-Generated
            </p>
          ) : (
            <p>
              {isAnalyzing
                ? "Analyzing text..."
                : "Analysis results will appear here."}
            </p>
          )}
          <button
            style={styles.analyzeButton}
            onClick={handleAnalyze}
            disabled={isAnalyzing}
          >
            {isAnalyzing ? "Analyzing..." : "Analyze text"}
          </button>
        </div>
      </main>
    </div>
  );
};

export default AIDetectorTool;
